import React, { useEffect } from "react";
import DashBoardCard from "./DashBoardCard";
import ShadowCard from "../../components/common/ShadowCard";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import LeadStatusCard from "./LeadStatusCard";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getDashboard,
  getDashboardUpcomingFollowUp,
} from "./services/dashboard.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { BiLockOpenAlt } from "react-icons/bi";
import {
  FaLockOpen,
  FaLock,
  FaTrophy,
  FaTimesCircle,
  FaCheckCircle,
  FaChartLine,
  FaPlus,
} from "react-icons/fa";
import { IoBarcodeOutline, IoReload } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { DateRangeFilter } from "../../_contstants/common";
import moment from "moment";
import { setDateFilter, setFollowupDateFilter } from "./dashboardSlice";
import FormDatePicker from "../../components/formFields/FormDateField";
import { getFilterFromToDate } from "../../_helper/helper";
import DashboardActivityCard from "./DashboardActivityCard";
import { AiOutlineFile, AiOutlinePhone, AiOutlineTeam } from "react-icons/ai";
import { PiStepsFill } from "react-icons/pi";
import { FaUserPlus } from "react-icons/fa6";
interface DateFilterChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DateFilterChangeWatcher: React.FC<DateFilterChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const SelectedDate = formRenderProps.valueGetter("SelectedDate");
  const FromDate = formRenderProps.valueGetter("FromDate");
  const ToDate = formRenderProps.valueGetter("ToDate");
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (SelectedDate !== 6) {
      formRenderProps.onChange("FromDate", { value: null });
      formRenderProps.onChange("ToDate", { value: null });
      const filter = getFilterFromToDate(SelectedDate);
      dispatch(getDashboard(filter));
      dispatch(setDateFilter({ SelectedDate, ...filter }));
    }
  }, [SelectedDate]);

  useEffect(() => {
    const filter = {
      FromDate: FromDate ? moment(FromDate).format("YYYY-MM-DD") : "",
      ToDate: ToDate ? moment(ToDate).format("YYYY-MM-DD") : "",
    };
    if (FromDate && ToDate) {
      dispatch(getDashboard(filter));
      dispatch(setDateFilter({ SelectedDate, FromDate, ToDate }));
    }
  }, [FromDate, ToDate]);
  return null;
};
const UpcomingFollowUpDateFilterChangeWatcher: React.FC<
  DateFilterChangeWatcherProps
> = ({ formRenderProps }) => {
  const SelectedDate = formRenderProps.valueGetter("SelectedDate");
  const FromDate = formRenderProps.valueGetter("FromDate");
  const ToDate = formRenderProps.valueGetter("ToDate");
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (SelectedDate !== 6) {
      formRenderProps.onChange("FromDate", { value: null });
      formRenderProps.onChange("ToDate", { value: null });
      const filter = getFilterFromToDate(SelectedDate);
      dispatch(
        getDashboardUpcomingFollowUp({
          FromFollowUpDate: filter?.FromDate,
          ToFollowUpDate: filter?.ToDate,
        }),
      );
      dispatch(setFollowupDateFilter({ SelectedDate, ...filter }));
    }
  }, [SelectedDate]);

  useEffect(() => {
    const filter = {
      FromDate: FromDate ? moment(FromDate).format("YYYY-MM-DD") : "",
      ToDate: ToDate ? moment(ToDate).format("YYYY-MM-DD") : "",
    };
    if (FromDate && ToDate) {
      dispatch(
        getDashboardUpcomingFollowUp({
          FromFollowUpDate: filter?.FromDate,
          ToFollowUpDate: filter?.ToDate,
        }),
      );
      dispatch(setFollowupDateFilter({ SelectedDate, FromDate, ToDate }));
    }
  }, [FromDate, ToDate]);
  return null;
};

const Dashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state?.dashboard?.loading);
  const gridRef = React.useRef<any>(null);
  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);
  const followupDateFilter = useAppSelector(
    (state) => state?.dashboard?.followupDateFilter,
  );
  const DashboardDetails = useAppSelector(
    (state) => state?.dashboard?.DashboardDetails,
  );
  const DashboardUpcomingFollowUpDetails = useAppSelector(
    (state) => state?.dashboard?.DashboardUpcomingFollowUpDetails,
  );
  useEffect(() => {
    if (!dateFilter?.SelectedDate) {
      const filter = {
        FromDate: "",
        ToDate: "",
      };
      dispatch(getDashboard(filter));
    }
    if (!followupDateFilter?.SelectedDate) {
      const filter = {
        FromDate: "",
        ToDate: "",
      };
      dispatch(
        getDashboardUpcomingFollowUp({
          FromFollowUpDate: filter?.FromDate,
          ToFollowUpDate: filter?.ToDate,
        }),
      );
    }
  }, []);

  const AmountDifferentiation = (value: number) => {
    const val = Math.abs(value || 0);
    const formatValue = (num: number) => {
      return num % 1 === 0 ? num?.toFixed(0) : num?.toFixed(2);
    };
    if (val >= 10000000) return `${formatValue(value / 10000000)} Cr`;
    if (val >= 100000) return `${formatValue(value / 100000)} Lac`;
    return formatValue(value);
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;

  const handleInquiryWisedata = (InquiryTypeID: number) => {
    navigate("/dashboard/inquirytypewiselist", {
      state: { InquiryTypeID, OperationType: 4 },
    });
  };
  const handleEmployeeWiseLeads = (UserID: number) => {
    navigate("/dashboard/employeewiselist", {
      state: { UserID, OperationType: 6 },
    });
  };
  const handleEmployeeWiseProspectLeads = (UserID: number) => {
    navigate("/dashboard/employeewiseprospectleadlist", {
      state: { UserID },
    });
  };

  // const handleEmployeeWiseInquiryAndLead = (UserID: number) => {
  //   navigate("/dashboard/employeewiseinquiryandlead", {
  //     state: { UserID },
  //   });
  // };

  const handleInquiryClosingAmount = (UserID: number) => {
    navigate("/dashboard/inquiryclosingamount", {
      state: { UserID },
    });
  };
  const handleLeadClosingAmount = (UserID: number) => {
    navigate("/dashboard/leadclosingamount", {
      state: { UserID },
    });
  };

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const allowedKeys = new Set(userResponse.map((item) => item.MenuKey));

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-8">
            <ShadowCard style={{ padding: 12 }}>
              <div className="container">
                <div className="row">
                  <div className="col-lg-4 mb-3">
                    <Typography.h6 style={{ margin: 0 }}>
                      My Dashboard
                    </Typography.h6>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-3">
                    <Typography.h6 style={{ margin: 0, textAlign: "start" }}>
                      Prospect Client Count :{" "}
                      <span
                        style={{ fontWeight: "bolder", color: "forestgreen" }}
                      >
                        {DashboardDetails?.ProspectCount}
                      </span>
                    </Typography.h6>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-3">
                    <Typography.h6 style={{ margin: 0, textAlign: "start" }}>
                      Group Code :{" "}
                      <span
                        style={{ fontWeight: "bolder", color: "forestgreen" }}
                      >
                        {DashboardDetails?.GroupCode}
                      </span>
                    </Typography.h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6 mb-3">
                    {" "}
                    <Link
                      to={"/dashboard/totalleadlist"}
                      state={{ OperationType: 2 }}
                      style={{ textDecoration: "none" }}
                    >
                      <DashBoardCard
                        icon={FaChartLine}
                        amount={DashboardDetails?.TotalInquiry || 0}
                        cardColor="#00CFE8"
                        title="Total Lead"
                      />
                    </Link>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-3">
                    {" "}
                    <Link
                      to={"/dashboard/totalopenleadlist"}
                      state={{
                        OperationType: 5,
                        LeadStatusID: 2,
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <DashBoardCard
                        icon={BiLockOpenAlt}
                        amount={DashboardDetails?.OpenNBInquiry || 0}
                        cardColor="#EA5455"
                        title="Open Lead"
                      />
                    </Link>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-3">
                    {" "}
                    <Link
                      to={"/dashboard/ownleadlist"}
                      state={{ OperationType: 3 }}
                      style={{ textDecoration: "none" }}
                    >
                      <DashBoardCard
                        icon={FaRegUser}
                        amount={DashboardDetails?.OwnInquiry || 0}
                        cardColor="#28C76F"
                        title="My Lead"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </ShadowCard>
            {/* ANY DO  */}
            {allowedKeys.has("anydo") && (
              <ShadowCard
                style={{
                  padding: 0,
                  marginTop: 20,
                  background: "#00ad47",
                  color: "#fff",
                }}
              >
                <div
                  className="container"
                  style={{
                    padding: 12,
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/anydo")}
                >
                  <div className="row">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                      <Typography.h6 style={{ margin: 0 }}>
                        Any Do
                      </Typography.h6>
                      <FaPlus />
                    </div>
                  </div>
                </div>
              </ShadowCard>
            )}
            {/* ACTIVITY  */}
            <ShadowCard style={{ padding: 12, marginTop: 20 }}>
              <Form
                onSubmit={() => {}}
                initialValues={followupDateFilter}
                render={(formRenderProps: FormRenderProps) => (
                  <FormElement style={{ width: "100%" }}>
                    <div className="container">
                      <div className="row">
                        <div className="col-12 mb-3">
                          <Typography.h6 style={{ margin: 0 }}>
                            Today's Follow-up
                          </Typography.h6>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.TodaysTasks &&
                              DashboardDetails?.TodaysTasks > 0
                                ? "/dashboard/todaytasks"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineFile}
                              amount={DashboardDetails?.TodaysTasks || 0}
                              cardColor="#6e78ff"
                              title="Tasks"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.TodaysCalls &&
                              DashboardDetails?.TodaysCalls > 0
                                ? "/dashboard/todaycalls"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlinePhone}
                              amount={DashboardDetails?.TodaysCalls || 0}
                              cardColor="#007991"
                              title="Calls"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.TodaysMeetings &&
                              DashboardDetails?.TodaysMeetings > 0
                                ? "/dashboard/todaymeetings"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineTeam}
                              amount={DashboardDetails?.TodaysMeetings || 0}
                              cardColor="#ff6e92"
                              title="Meetings"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-md-6 mb-3 d-flex align-items-end">
                          <Typography.h6 style={{ margin: 0 }}>
                            Upcoming Follow Up
                          </Typography.h6>
                        </div>
                        <div className="col-lg-8 col-md-6 mb-3 d-flex justify-content-end align-items-end align-items-lg-center flex-column flex-lg-row gap-1">
                          {formRenderProps.valueGetter("SelectedDate") ===
                            6 && (
                            <>
                              <Field
                                wrapperStyle={{
                                  margin: "0 0 0 10px",
                                  width: 150,
                                  flex: "none",
                                }}
                                name="FromDate"
                                component={FormDatePicker}
                                size={"small"}
                                placeholder="From Date"
                              />
                              <Field
                                wrapperStyle={{
                                  margin: "0 0 0 10px",
                                  width: 150,
                                  flex: "none",
                                }}
                                name="ToDate"
                                component={FormDatePicker}
                                size={"small"}
                                minDate={formRenderProps.valueGetter(
                                  "FromDate",
                                )}
                                placeholder="To Date"
                              />
                            </>
                          )}
                          <Field
                            wrapperStyle={{
                              margin: "0 0 0 10px",
                              width: 150,
                              flex: "none",
                            }}
                            name="SelectedDate"
                            component={FormSelectionField}
                            size={"small"}
                            placeholder="Filter"
                            options={DateRangeFilter?.map((date: any) => {
                              return {
                                value: date.value,
                                label: date.label,
                              };
                            })}
                          />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardUpcomingFollowUpDetails?.UpComingTasks &&
                              DashboardUpcomingFollowUpDetails?.UpComingTasks >
                                0
                                ? "/dashboard/upcommingtasks"
                                : ""
                            }
                            state={{
                              FromDate: followupDateFilter?.FromDate
                                ? moment(followupDateFilter?.FromDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                              ToDate: followupDateFilter?.ToDate
                                ? moment(followupDateFilter?.ToDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineFile}
                              amount={
                                DashboardUpcomingFollowUpDetails?.UpComingTasks ||
                                0
                              }
                              cardColor="#6e78ff"
                              title="Tasks"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardUpcomingFollowUpDetails?.UpComingCalls &&
                              DashboardUpcomingFollowUpDetails?.UpComingCalls >
                                0
                                ? "/dashboard/upcommingcalls"
                                : ""
                            }
                            state={{
                              FromDate: followupDateFilter?.FromDate
                                ? moment(followupDateFilter?.FromDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                              ToDate: followupDateFilter?.ToDate
                                ? moment(followupDateFilter?.ToDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlinePhone}
                              amount={
                                DashboardUpcomingFollowUpDetails?.UpComingCalls ||
                                0
                              }
                              cardColor="#007991"
                              title="Calls"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardUpcomingFollowUpDetails?.UpComingMeetings &&
                              DashboardUpcomingFollowUpDetails?.UpComingMeetings >
                                0
                                ? "/dashboard/upcommingmeetings"
                                : ""
                            }
                            state={{
                              FromDate: followupDateFilter?.FromDate
                                ? moment(followupDateFilter?.FromDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                              ToDate: followupDateFilter?.ToDate
                                ? moment(followupDateFilter?.ToDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : "0",
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineTeam}
                              amount={
                                DashboardUpcomingFollowUpDetails?.UpComingMeetings ||
                                0
                              }
                              cardColor="#ff6e92"
                              title="Meetings"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <Typography.h6 style={{ margin: 0 }}>
                            Missed Follow Up
                          </Typography.h6>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.MissedTasks &&
                              DashboardDetails?.MissedTasks > 0
                                ? "/dashboard/missedtasks"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineFile}
                              amount={DashboardDetails?.MissedTasks || 0}
                              cardColor="#6e78ff"
                              title="Tasks"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.MissedCalls &&
                              DashboardDetails?.MissedCalls > 0
                                ? "/dashboard/missedcalls"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlinePhone}
                              amount={DashboardDetails?.MissedCalls || 0}
                              cardColor="#007991"
                              title="Calls"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.MissedMeetings &&
                              DashboardDetails?.MissedMeetings > 0
                                ? "/dashboard/missedmeetings"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={IoBarcodeOutline}
                              amount={DashboardDetails?.MissedMeetings || 0}
                              cardColor="#ff6e92"
                              title="Meetings"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <hr className="mt-0" />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link to={""} style={{ textDecoration: "none" }}>
                            <DashboardActivityCard
                              icon={FaUserPlus}
                              amount={DashboardDetails?.GroupCode || 0}
                              cardColor="#f5be7de8"
                              title="Group Code"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link to={""} style={{ textDecoration: "none" }}>
                            <DashboardActivityCard
                              icon={PiStepsFill}
                              amount={DashboardDetails?.ProspectCount || 0}
                              cardColor="#99abf9"
                              title="Prospect Client"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={
                              DashboardDetails?.OpportunityCount &&
                              DashboardDetails?.OpportunityCount > 0
                                ? "/dashboard/opportunity"
                                : ""
                            }
                            style={{ textDecoration: "none" }}
                          >
                            <DashboardActivityCard
                              icon={AiOutlineTeam}
                              amount={DashboardDetails?.OpportunityCount || 0}
                              cardColor="#ff9292"
                              title="Opportunity"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <UpcomingFollowUpDateFilterChangeWatcher
                      formRenderProps={formRenderProps}
                      // setDateRange={setDateRange}
                    />
                  </FormElement>
                )}
              />
            </ShadowCard>
            {/* LEAD STATUS */}
            <ShadowCard style={{ padding: 12, marginTop: 20 }}>
              <Form
                onSubmit={() => {}}
                initialValues={dateFilter}
                render={(formRenderProps: FormRenderProps) => (
                  <FormElement style={{ width: "100%" }}>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Typography.h6 style={{ margin: 0 }}>
                            Lead Status
                          </Typography.h6>
                        </div>
                        <div className="col-lg-8 col-md-6 mb-3 d-flex justify-content-end align-items-end align-items-lg-center flex-column flex-lg-row">
                          {formRenderProps.valueGetter("SelectedDate") ===
                            6 && (
                            <>
                              <Field
                                wrapperStyle={{
                                  margin: "0 0 0 10px",
                                  width: 150,
                                  flex: "none",
                                }}
                                name="FromDate"
                                component={FormDatePicker}
                                size={"small"}
                                placeholder="From Date"
                              />
                              <Field
                                wrapperStyle={{
                                  margin: "0 0 0 10px",
                                  width: 150,
                                  flex: "none",
                                }}
                                name="ToDate"
                                component={FormDatePicker}
                                size={"small"}
                                minDate={formRenderProps.valueGetter(
                                  "FromDate",
                                )}
                                placeholder="To Date"
                              />
                            </>
                          )}
                          <Field
                            wrapperStyle={{
                              margin: "0 0 0 10px",
                              width: 150,
                              flex: "none",
                            }}
                            name="SelectedDate"
                            component={FormSelectionField}
                            size={"small"}
                            placeholder="Filter"
                            options={DateRangeFilter?.map((date: any) => {
                              return {
                                value: date.value,
                                label: date.label,
                              };
                            })}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            style={{ textDecoration: "none" }}
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[0]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                          >
                            <LeadStatusCard
                              icon={FaCheckCircle}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[0]
                                  ?.LeadStatusCount
                              }
                              cardColor="#7FE7F3"
                              title="Alloted"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[1]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <LeadStatusCard
                              icon={FaLockOpen}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[1]
                                  ?.LeadStatusCount
                              }
                              cardColor="#F4A9AA"
                              title="Open"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[2]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <LeadStatusCard
                              icon={IoReload}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[2]
                                  ?.LeadStatusCount
                              }
                              cardColor="#B9B3F7"
                              title="Process"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          {" "}
                          <Link
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[3]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <LeadStatusCard
                              icon={FaTimesCircle}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[3]
                                  ?.LeadStatusCount
                              }
                              cardColor="#93E3B7"
                              title="Not-Alloted"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <Link
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[4]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <LeadStatusCard
                              icon={FaLock}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[4]
                                  ?.LeadStatusCount
                              }
                              cardColor="#8BB9F4"
                              title="Close"
                            />
                          </Link>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          {" "}
                          <Link
                            to={"/dashboard/leadstatuswiselist"}
                            state={{
                              OperationType: 5,
                              LeadStatusID:
                                DashboardDetails?.LeadStatusWiseCount[5]
                                  ?.LeadStatusID,
                              FromDate: dateFilter?.FromDate,
                              ToDate: dateFilter?.ToDate,
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <LeadStatusCard
                              icon={FaTrophy}
                              amount={
                                DashboardDetails?.LeadStatusWiseCount[5]
                                  ?.LeadStatusCount
                              }
                              cardColor="#FFCFA1"
                              title="WON"
                            />
                          </Link>
                        </div>
                      </div>
                      <DateFilterChangeWatcher
                        formRenderProps={formRenderProps}
                        // setDateRange={setDateRange}
                      />
                    </div>
                  </FormElement>
                )}
              />
            </ShadowCard>

            {DashboardDetails?.EmployeeWiseInquiryCloseAmount.length > 0 && (
              <ShadowCard style={{ padding: 12, marginTop: 20 }}>
                <h6 style={{ color: "forestgreen" }}>
                  Employee Wise Inquiry Closing Amount
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "gainsboro" }}>Sr.No</th>
                      <th style={{ background: "gainsboro" }}>Name</th>
                      <th style={{ background: "gainsboro" }}>Inquiry</th>
                      <th style={{ background: "gainsboro" }}>
                        Closing Amount
                      </th>
                      {/* <th style={{ background: "gainsboro" }}>Total</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardDetails?.EmployeeWiseInquiryCloseAmount?.map(
                      (item: any, ind: number) => (
                        <tr
                          key={ind}
                          onClick={() =>
                            handleInquiryClosingAmount(item?.UserID)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <td>{ind + 1}</td>
                          <td
                            className="hoverableName"
                            style={{ fontWeight: "bold" }}
                          >
                            {item?.UserName}
                          </td>
                          <td>{item?.InquiryCount}</td>
                          <td>
                            ₹{AmountDifferentiation(item?.InquiryClosingAmount)}
                          </td>
                          {/* <td>₹{AmountDifferentiation(item?.Total)}</td> */}
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </ShadowCard>
            )}
            {DashboardDetails?.EmployeeWiseLeadCloseAmount.length > 0 && (
              <ShadowCard style={{ padding: 12, marginTop: 20 }}>
                <h6 style={{ color: "forestgreen" }}>
                  Employee Wise Lead Closing Amount
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "gainsboro" }}>Sr.No</th>
                      <th style={{ background: "gainsboro" }}> Name</th>
                      <th style={{ background: "gainsboro" }}>Lead</th>
                      <th style={{ background: "gainsboro" }}>
                        Closing Amount
                      </th>
                      {/* <th style={{ background: "gainsboro" }}>Total</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardDetails?.EmployeeWiseLeadCloseAmount?.map(
                      (item: any, ind: number) => (
                        <tr
                          key={ind}
                          onClick={() => handleLeadClosingAmount(item?.UserID)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{ind + 1}</td>
                          <td
                            className="hoverableName"
                            style={{ fontWeight: "bold" }}
                          >
                            {item?.UserName}
                          </td>
                          <td>{item?.LeadCount}</td>
                          <td>
                            ₹{AmountDifferentiation(item?.LeadClosingAmount)}
                          </td>
                          {/* <td>₹{AmountDifferentiation(item?.Total)}</td> */}
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </ShadowCard>
            )}
            {DashboardDetails?.EmployeeWiseProspectsCounts.length > 0 && (
              <ShadowCard style={{ padding: 12, marginTop: 20 }}>
                <h6 style={{ color: "forestgreen" }}>
                  Employee Wise Prospect Leads
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "gainsboro" }}>Sr.No</th>
                      <th style={{ background: "gainsboro" }}>Name</th>
                      <th style={{ background: "gainsboro" }}>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardDetails?.EmployeeWiseProspectsCounts?.map(
                      (item: any, ind: number) => (
                        <tr
                          key={ind}
                          onClick={() =>
                            handleEmployeeWiseProspectLeads(item?.UserID)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <td>{ind + 1}</td>
                          <td
                            className="hoverableName"
                            style={{ fontWeight: "bold" }}
                          >
                            {item?.UserName}
                          </td>
                          <td>{item?.ProsepectTotalCount}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </ShadowCard>
            )}
          </div>
          <div className="col-xl-4 mt-3 mt-xl-0">
            {DashboardDetails?.InquiryTypeWiseCounts.length > 0 && (
              <ShadowCard style={{ padding: 12 }}>
                <h6 style={{ color: "forestgreen" }}>Inquiry Type List</h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "gainsboro" }}>Inquiry Type</th>
                      <th style={{ background: "gainsboro" }}>Count</th>
                      <th style={{ background: "gainsboro" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardDetails?.InquiryTypeWiseCounts?.map(
                      (item: any, idx: any) => (
                        <tr
                          style={{ cursor: "pointer" }}
                          key={idx}
                          onClick={() =>
                            handleInquiryWisedata(item?.InquiryTypeID)
                          }
                        >
                          <td
                            className="hoverableName"
                            style={{ fontWeight: "bold" }}
                          >
                            {item?.InquiryType}
                          </td>
                          <td> {item?.InquiryTypeCount}</td>
                          <td width={100}>
                            ₹{AmountDifferentiation(item?.ProposedAmount)}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </ShadowCard>
            )}
            {DashboardDetails?.EmployeeWiseCounts?.length > 0 && (
              <ShadowCard style={{ padding: 12, marginTop: 20 }}>
                <h6 style={{ color: "forestgreen" }}>Employee Wise Leads</h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "gainsboro" }}>Sr.No</th>
                      <th style={{ background: "gainsboro" }}>Employee Name</th>
                      <th style={{ background: "gainsboro" }}>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardDetails?.EmployeeWiseCounts?.map(
                      (item: any, ind: number) => (
                        <tr
                          key={ind}
                          onClick={() => handleEmployeeWiseLeads(item?.UserID)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{ind + 1}</td>
                          <td
                            className="hoverableName"
                            style={{ fontWeight: "bold" }}
                          >
                            {item.UserName}
                          </td>
                          <td>{item.InquiryTotalCount}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </ShadowCard>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
